import React, { useState } from 'react'
import { connect } from 'react-redux'

import CondoBuilderResults from '../components/CondoBuilderResults'
import CondoBuilderForms from '../components/CondoBuilderForms'
import { fetchCondoReport, newSearchCondoReport, fetchHomeBuilders, newSearchHomeBuilder } from '../actions/condoBuilderActions'
import LgyLoadingIcon from 'app/components/util/lgy-loading-icon/LgyLoadingIcon'

import '../style/condos-builders.scss'
import { searchTypes } from '../constants/search-types'

const CondoBuilderContainer = (props) => {
  const [values, setValues] = useState({
    name: '',
    id: '',
    station: '',
    city: '',
    stateCode: '',
    county: '',
    approved: false,
    firstName: '',
    lastName: '',
    searchType: searchTypes.STARTS_WITH
  })
  const [errors, setErrors] = useState({})
  const [pageOfItems, setPages] = useState([])

  const handleChange = (event) => {
    let target = event.target
    if (target.name === 'id') { target.value = target.value.replace(/(\W)*/g, '') }
    setValues({ ...values, [target.name]: target.type === 'checkbox' ? target.checked : target.value })
    setErrors({})
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    if (props.condo) {
      props.fetchCondoReport(values)
    } else if (props.builder) {
      props.fetchHomeBuilders(values)
    }
  }

  const handleInvalid = (event) => {
    event.preventDefault()
    let target = event.target
    if (target.name === 'id') {
      setErrors({ ...errors, [event.target.name]: `Must be ${props.condo ? '6' : '5'} characters, use leading zeros if needed.` })
    } else {
      setErrors({ ...errors, [event.target.name]: 'Required' })
    }
  }

  const handleReset = () => {
    setValues({
      name: '',
      id: '',
      station: '',
      city: '',
      stateCode: '',
      county: '',
      approved: false,
      firstName: '',
      lastName: '',
      searchType: searchTypes.STARTS_WITH

    })
    setErrors({})
    if (props.condo) {
      props.newSearchCondoReport()
    } else if (props.builder) {
      props.newSearchHomeBuilder()
    }
  }

  if ((props.condo && props.condoReport.fetching) || (props.builder && props.homeBuilder.fetching)) {
    return <LgyLoadingIcon className='condo-builder' />
  } else if ((props.condo && props.condoReport.list && props.condoReport.list.length > 0) ||
    (props.builder && props.homeBuilder.list && props.homeBuilder.list.length > 0)) {
    return <CondoBuilderResults
      minMode={props.minMode}
      whichReport={props.condo ? 'Condo' : 'Builder'}
      condoReport={props.condoReport}
      homeBuilder={props.homeBuilder}
      pageOfItems={pageOfItems}
      onPageChange={(pageOfItems) => setPages(pageOfItems)}
      handleReset={handleReset} />
  } else {
    return <CondoBuilderForms
      minMode={props.minMode}
      whichReport={props.condo ? 'Condo' : 'Builder'}
      handleSubmit={handleSubmit}
      handleChange={handleChange}
      handleInvalid={handleInvalid}
      handleReset={handleReset}
      condoReport={props.condoReport}
      homeBuilder={props.homeBuilder}
      values={values}
      errors={errors}
      stations={props.stations} />
  }
}

const mapStateToProps = state => ({
  stations: state.stations.stations ? state.stations.stations : [],
  condoReport: state.condoReport,
  homeBuilder: state.homeBuilder
})

const mapDispatchToProps = { fetchCondoReport, newSearchCondoReport, fetchHomeBuilders, newSearchHomeBuilder }

export default connect(mapStateToProps, mapDispatchToProps)(CondoBuilderContainer)
